<template>
    <div class="tabs-container">
        <TabButton v-for="tab in currentTabs"
                   :key="tab.id"
                   @click.native="tabClick(tab)"
                   class="tab"
                   :text="tab.name"
                   :icon="tab.icon"
                   :isFocused="isFocusedTab(tab)">

        </TabButton>
    </div>
</template>

<script>
    import TabButton from "@/shared/components/button/TabButton";

    export default {
        name: "TabContainer",
        components: {TabButton},
        props: {
            tabs: Array
        },
        data() {
            return {
                currentTabs: this.tabs
            }
        },
        methods: {
            tabClick(tab) {
                if (!this.isFocusedTab(tab)) {
                    this.$router.push(tab.link);
                }
            },
            isFocusedTab(tab) {
                return this.$route.path.includes(tab.link);
            }
        },
        watch: {
            tabs: {
                handler(newVal) {
                    this.currentTabs = newVal;
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .tabs-container {
        margin-top: 40px;
    }

    .tab {
        float: left;
        width: fit-content;
        margin: 0 10px;
    }
</style>